module.exports = __webpack_public_path__ + "media/images/icon__live@2x-b1fbcc8fc7ef7612d3edb9a32fade763.png";